import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Meine Produkte')
        .setRoute('current_user_product_list'),
];
